import type { NftCollection } from '@ui/queries/types';
import type { VenoSDK, VenoTransaction } from '@veno-app/sdk';

import type { CollectionNft } from '../types';

export const checkNftCollectionApproved = (
  collection: NftCollection,
  owner: string,
  sdk: VenoSDK,
): Promise<boolean> => {
  switch (collection) {
    case 'CRUISER':
      return sdk.Cruiser.isStormApproved(owner);
    case 'MOLE':
      return sdk.MinerMole.isStormApproved(owner);
    case 'BoomerSquad':
      return sdk.BoomerSquad.isStormApproved(owner);
  }
};

const approveCollection = async (
  collection: NftCollection,
  sdk: VenoSDK,
): Promise<VenoTransaction> => {
  switch (collection) {
    case 'CRUISER':
      return await sdk.Cruiser.approveStorm();
    case 'MOLE':
      return await sdk.MinerMole.approveStorm();
    case 'BoomerSquad':
      return await sdk.BoomerSquad.approveStorm();
  }
};

export const approveNecessaryCollections = async (
  tokens: CollectionNft[],
  setNumberTransactionSteps: (n: number) => void,
  setCurrentTransactionStep: (n: number) => void,
  owner: string,
  sdk: VenoSDK,
) => {
  const collections = [...new Set(tokens.map((t) => t.collection))];
  const approved = await Promise.all(
    collections.map((c) => checkNftCollectionApproved(c, owner, sdk)),
  );

  setNumberTransactionSteps(1 + approved.filter((a) => !a).length);
  setCurrentTransactionStep(1);
  let currentTransactionStep = 1;
  for (let i = 0; i < approved.length; i++) {
    if (!approved[i]) {
      const approveRet = await approveCollection(collections[i], sdk);
      await approveRet.txReceiptPromise;
      currentTransactionStep++;
      setCurrentTransactionStep(currentTransactionStep);
    }
  }
};
